import React from 'react'

import Navigation from './../../landing/components/Nav'
import RefundComponent from './../../landing/components/RefundPrivacy'
import Footer from './../../landing/components/Footer'


const Refund = props => {
	return (
		<>
			<Navigation />
			<RefundComponent />
			<Footer />
		</>
	)
}

export default Refund